module.exports = __webpack_public_path__ + "assets/groupTrip.92447e0e.svg";